import React from "react";
import "./FeaturesSection.css";
import { FaBoxOpen, FaShieldAlt, FaScroll, FaTag } from "react-icons/fa";

function FeaturesSection() {
  const features = [
    {
      icon: <FaBoxOpen />,
      title: "Stealth & Discreet Packaging",
      desc: "All orders from LushDesire.in are delivered in 100% unmarked and plain packaging to ensure complete privacy.",
    },
    {
      icon: <FaTag />,
      title: "Premium Quality Sex Toys",
      desc: "We offer high-quality, body-safe and certified personal wellness products tested for safety and durability.",
    },
    {
      icon: <FaScroll />,
      title: "Safe & Secure Billing",
      desc: "Your billing statements show a generic company name with no explicit or sensitive words.",
    },
    {
      icon: <FaShieldAlt />,
      title: "100% Privacy Protection",
      desc: "Your personal data, identity, and order details are always secure and fully protected with us.",
    },
  ];

  return (
    <section
      className="features-section"
      aria-label="Why choose LushDesire online sex toy store in India"
    >
      <div className="container">
        {/* 🔥 SEO HEADING */}
        <h2 className="features-heading">
          Why Choose LushDesire.in – India’s Trusted Online Sex Toy Store
        </h2>

        <div className="features-grid">
          {features.map((item, index) => (
            <div className="feature-box" key={index}>
              <div className="feature-icon" aria-hidden="true">
                {item.icon}
              </div>

              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturesSection;
